import * as yup from 'yup';

import i18n from '../../../i18n/configs';

const emailValidation = yup
  .string()
  .lowercase()
  .required(i18n.t('validation.error.required'))
  .email(i18n.t('validation.error.email'))
  .max(250, i18n.t('validation.error.below250'))
  .matches(
    /^(?!.*(^[\w.+]+(@gmail\.com|@yahoo\.co\.jp|@aol\.jp|@icloud\.com|@outlook\.jp|@outlook\.com|@hotmail\.com|@live\.jp|@docomo\.ne\.jp|@ezweb\.ne\.jp|@softbank\.ne\.jp|@[\w.+]+.vodafone\.ne\.jp)$)).+$/,
    i18n.t('validation.error.specificEmail')
  );

export const passwordValidataion = yup
  .string()
  .required(i18n.t('validation.error.required'))
  .min(6, i18n.t('validation.error.min'))
  .matches(
    /(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!-/:-@[-`{-~])[a-zA-z0-9!-/:-@[-`{-~]|(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-z0-9]|(?=.*[a-zA-Z])(?=.*[!-/:-@[-`{-~])[a-zA-z!-/:-@[-`{-~]|(?=.*[0-9])(?=.*[!-/:-@[-`{-~])[0-9!-/:-@[-`{-~]{6,}/,
    i18n.t('validation.error.mixed')
  )
  .max(250, i18n.t('validation.error.below250'));

export const schema = yup.object().shape({
  email: emailValidation,
  privacyCheck: yup.bool().oneOf([true], i18n.t('validation.error.required'))
});

export const loginSchema = yup.object().shape({
  email: emailValidation,
  password: passwordValidataion
});

export const passwordChangeSchema = yup.object().shape({
  password: passwordValidataion,
  password_confirm: yup
    .string()
    .oneOf([yup.ref('password'), null], i18n.t('passwordReset.notMatch'))
});
